module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel03_770_280_th-ed8b0519a0441326fee12674ae60ac17.jpg";